var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeposit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8388 9H10.6612C9.74313 9 9 9.7175 9 10.6039V16.7289C9 17.6152 9.74313 18.3327 10.6612 18.3327H11.4161V17.0202C11.4161 16.2966 12.026 15.7077 12.7754 15.7077H14.2862C15.0356 15.7077 15.6455 16.2966 15.6455 17.0202V18.3327H16.8536V17.0202C16.8536 16.2966 17.4635 15.7077 18.2129 15.7077H19.7237C20.4731 15.7077 21.083 16.2966 21.083 17.0202V18.3327H21.8262C22.7442 18.3327 23.4873 17.6152 23.4873 16.7289L23.4991 10.6039C23.5 9.7175 22.7569 9 21.8388 9ZM12.1719 11.625H11.2656C11.0155 11.625 10.8125 11.429 10.8125 11.1875C10.8125 10.946 11.0155 10.75 11.2656 10.75H12.1719C12.422 10.75 12.625 10.946 12.625 11.1875C12.625 11.429 12.422 11.625 12.1719 11.625ZM16.25 15.4164C15.2504 15.4164 14.4375 14.6315 14.4375 13.6664C14.4375 12.7012 15.2504 11.9164 16.25 11.9164C17.2496 11.9164 18.0625 12.7012 18.0625 13.6664C18.0625 14.6315 17.2496 15.4164 16.25 15.4164Z",
    fill: "#EDE3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1767 19.209C20.1767 21.2967 18.4131 23.0004 16.2499 23.0004C14.0867 23.0004 12.3231 21.2967 12.3231 19.209H14.77C14.9087 19.874 15.5186 20.3754 16.2499 20.3754C16.9812 20.3754 17.5912 19.874 17.7298 19.209H20.1767Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7392 17.0215V18.334H12.3223V17.0215C12.3223 16.7826 12.528 16.584 12.7754 16.584H14.2861C14.5344 16.584 14.7392 16.7817 14.7392 17.0215Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1767 17.0215V18.334H17.7598V17.0215C17.7598 16.7826 17.9655 16.584 18.2129 16.584H19.7236C19.9719 16.584 20.1767 16.7817 20.1767 17.0215Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeposit);
export default __webpack_public_path__ + "static/media/deposit.6cf806949c3bedf86c8488fb93ef8fac.svg";
export { ForwardRef as ReactComponent };